export const getWordWithLowerCase = (str: string) => str.toLocaleLowerCase();
